import { createGenericColumn } from '../../../utils/table-headers-utils';

export const sitesColumns = [createGenericColumn('Site Name')];
